import { getRequest } from '../services/http';
import axios, { AxiosInstance } from 'axios';

// const authChangePhone = "/api/v0/auth/change-phone/"
// const authSocialPhoneEmail = "/api/v0/auth/signin/social/phone-email/"
// const authSignInFacebookConfirmEmail = "/api/v0/auth/signin/facebook/confirm-email/"

export function onlineUsersCount() {
  return getRequest('users-online/');
}

export function signIn(data: Object = {}): Promise<any> {
  return client.post('auth/signin/', data);
}

export function signInViaPhone(data: Object = {}): Promise<any> {
  return client.post('auth/signin/signin-phone/', data);
}

export function signUp(data: Object = {}): Promise<any> {
  return client.post('auth/signup/', data);
}

export function signUpConfirm(data: Object = {}): Promise<any> {
  return client.post('auth/signup/confirm/', data);
}

export function resendCode(data: Object = {}): Promise<any> {
  return client.post('auth/resend-code/', data);
}

// @takes a valid email address
// @returns a { security_token: '' } in return.
export function passwordRecovery(data: Object = {}): Promise<any> {
  return client.post('auth/password/recover/', data);
}

export function passwordRecoveryConfirm(data: Object = {}): Promise<any> {
  return client.post('auth/password/recover/confirm/', data);
}

export function passwordRecoveryReset(data: Object = {}): Promise<any> {
  return client.post('auth/password/recover/set-new/', data);
}

export function oauthApple(data: Object = {}): Promise<any> {
  return client.post('auth/signin/ios/', data);
}

export function oauthGoogle(data: Object = {}): Promise<any> {
  return client.post('auth/signin/google/', data);
}

export function oauthTwitch(data: Object = {}): Promise<any> {
  return client.post('auth/signin/twitch/', data);
}

export function oauthFacebook(data: Object = {}): Promise<any> {
  return client.post('auth/signin/facebook', data);
}

export function getProfile(): Promise<any> {
  return client.get('profile/');
}
export function getMe(): Promise<any> {
  return client.get('me/');
}
export function getUsers(): Promise<any> {
  return client.get('users/');
}


export function postBet(bet:any): Promise<any> {
  
    // let url = "http://localhost:8000/api/v0/bets/"

    // await fetch(url, {
    //     method: 'POST',
    //     headers: {
    //         'Accept': 'application/json',
    //         'Content-Type': 'application/json',
    //         "authorization": "Token " + loadFromStorage("token")
    //     },
    //     body: JSON.stringify(bet)
    // });
    // const result = await response.json();

  return client.post('bets/', bet);
}

export function verifyGameAccount(data: any): Promise<any> {
  
  // return fetch("http://localhost:8000/api/v0/verify/", {
  //     method: "POST",
  //     headers: {
  //         "Content-Type": "application/json"
  //     },
  //     body: JSON.stringify({ game_id, game_username }),
  //     credentials: "include"
  // });
  return client.post('verify/', data);
}


let host = "http://localhost:8005";
if(window.location.hostname != "localhost"){
  host = "https://gsdemoapi.dgen.solutions";
}

export const client: AxiosInstance = axios.create({
  baseURL: host + '/api/v0',
  timeout: 10000,
  responseType: 'json' as const,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

/// If client request fails, send to login
client.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401 || error.response.status === 403) {
      localStorage.removeItem('token');
      document.location.reload();
    }
    return Promise.reject(error);
  }
);